import TeacherEnrollAudit from './src/main';

/* istanbul ignore next */
TeacherEnrollAudit.install = function(Vue) {
  Vue.component(TeacherEnrollAudit.name, TeacherEnrollAudit);
};

export default TeacherEnrollAudit;
